import React, {
    useContext,
    useState,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from '../router';

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';

const membershipId = OPTIONS.BasketMembership?.id?.innerHTML || null;

export default function MembershipPrompt(props) {
    const { notification, setNotification } = useContext(NotificationContext);
    const [membershipJustAdded, setMembershipJustAdded] = useState(false);

    const {
        isFetching: isPotentialDiscountDataFetching,
        data: potentialDiscountData,
    } = useQuery({
        queryKey: ['potentialDiscountData', membershipId],
        queryFn: () => QUERIES.getPotentialDiscount(membershipId),
        refetchOnWindowFocus: false,
        retry: false
    });

    const addMembership = useMutation({
        mutationFn: () => QUERIES.addMembership([{ membership: membershipId, autoRenew: true }]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            setMembershipJustAdded(true);
            refetchBasketData();
            const iframe = document.querySelector('iframe');
            if (iframe) {
                iframe.src = iframe.src; // Reload iframe
            }
        },
    });

    // Early exit if basket not ready or query still fetching
    if (!props.basketData || isPotentialDiscountDataFetching) return null;

    const membershipList = props.basketData?.membershipSubscriptions || [];

    // Show prompt only if no memberships or only "Key Keeper"
    const onlyHasKeyKeeper = membershipList.length > 0 &&
        membershipList.every((m) => m?.membership?.name === 'Key Keeper');

    // If there are memberships and not exclusively "Key Keeper", hide prompt
    if (membershipList.length && !onlyHasKeyKeeper) return null;

    const basketIsEmpty = !props.basketData.tickets?.length &&
        !props.basketData.membershipSubscriptions?.length &&
        !props.basketData.donations?.length &&
        !props.basketData.giftVouchers?.length &&
        !props.basketData.merchandiseItems?.length;

    return (
        <section className="membership-upsale here">
            {props.basketData.customer?.subscriptions?.length || basketIsEmpty ? (
                <></>
            ) : (
                <div className="membership-prompt--inner">
                    {props.basketData.membershipSubscriptions?.length ? (
                        <>
                            <h2
                                className="booking-pathway__header"
                                dangerouslySetInnerHTML={{ __html: OPTIONS.BasketMembership.Thankstitle.innerHTML }}
                            />
                            <div
                                className="membership-prompt--description"
                                dangerouslySetInnerHTML={{ __html: OPTIONS.BasketMembership.Thanksintroduction.innerHTML }}
                            />
                        </>
                    ) : potentialDiscountData?.totalDiscount && !props.basketData?.totalDiscount ? (
                        <>
                            <h2 className="booking-pathway__header">
                                {`Save £${potentialDiscountData.totalDiscount.toFixed(2)} by joining as a member today`}
                            </h2>
                            {OPTIONS.BasketMembership.Thanksintroduction.innerHTML && (
                                <div
                                    className="membership-prompt--description"
                                    dangerouslySetInnerHTML={{ __html: OPTIONS.BasketMembership.Thanksintroduction.innerHTML }}
                                />
                            )}
                            <div className="membership-prompt--button">
                                <button type="button" className="btn" onClick={() => addMembership.mutate()}>
                                    Join now
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <h3>You could save up to 15% on tickets by joining as a member today</h3>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: OPTIONS.BasketMembership.introduction.innerHTML,
                                }}
                            />
                            <button
                                className="btn btn--icon white"
                                onClick={() => addMembership.mutate()}
                            >
                                Join now
                            </button>
                        </>
                    )}
                </div>
            )}
        </section>
    );
}
